import { z } from 'zod';
import { API_PREFIX, defineEndpoint } from '../endpoint';

/**
 * A session raised to administrator by the console's `admin "<password>"` (ADMIN-CONSOLE): the
 * dev tools answer it from anywhere, until it is dropped (`admin off`) or the session ends.
 * The password travels once, in this body, and is never logged, kept or echoed.
 */
export const elevateAdmin = defineEndpoint({
  method: 'POST',
  path: `${API_PREFIX}/me/admin`,
  access: 'account',
  body: z.object({ password: z.string().min(1).max(256) }),
  response: z.object({ admin: z.literal(true) }),
});

/** Back to a plain session (`admin off`). Dropping a session that is not raised does nothing. */
export const dropAdmin = defineEndpoint({
  method: 'DELETE',
  path: `${API_PREFIX}/me/admin`,
  access: 'account',
  response: z.object({ admin: z.literal(false) }),
});

/**
 * Whether the session is raised, and whether the dev tools answer it (on, and straight from this
 * machine or raised: the /dev guard's own rule). The console and the dev panel ask it on loading;
 * F4 shows by `devTools`, never by probing /dev.
 */
export const getAdmin = defineEndpoint({
  method: 'GET',
  path: `${API_PREFIX}/me/admin`,
  access: 'account',
  response: z.object({ admin: z.boolean(), devTools: z.boolean() }),
});
